import React, { useEffect, useState } from "react";
import { Button, Label, Modal, TextInput, Textarea } from "flowbite-react";
import { toast } from "react-toastify";
import ScheduleEventsApi from "../../Api/ScheduleEventsApi";
import { ContactForm } from "../../Models/ContactForm";

interface RequestDemoModalProps {
  show: boolean;
  onClose: () => void;
}

const emptyForm = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  companyName: "",
  questionsComments: "",
  website: "",
  formOpenedAt: new Date().toISOString(),
};

const RequestDemoModal: React.FC<RequestDemoModalProps> = ({
  show,
  onClose,
}) => {
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setForm({
        ...emptyForm,
        website: "",
        formOpenedAt: new Date().toISOString(),
      });
    }
  }, [show]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.email || !form.firstName || !form.lastName) {
      toast.error("First Name, Last Name, and Email are required.");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...form,
        id: 0,
        subject: "Demo Request",
        clientId: null,
        contactId: null,
      } as ContactForm;

      ScheduleEventsApi.requestDemo(payload)
        .then((res) => {
          if (res.data === false) {
            toast.error("Unable to send demo request. Please try again.");
            return;
          }
          toast.success("Demo request sent!");
          setForm({
            ...emptyForm,
            formOpenedAt: new Date().toISOString(),
          });
          onClose();
        })
        .catch((err) => {
          onClose();
          toast.error("Failed to send request.");
          console.error(err);
        });
    } catch (err) {
      toast.error("Failed to send request.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onClose={onClose}>
      <Modal.Header>Request a Demo</Modal.Header>
      <Modal.Body>
        <div className="space-y-4 relative">
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              left: "-10000px",
              top: "auto",
              width: "1px",
              height: "1px",
              overflow: "hidden",
            }}
          >
            <label htmlFor="demo-website">Website</label>
            <input
              id="demo-website"
              name="website"
              type="text"
              tabIndex={-1}
              autoComplete="off"
              value={form.website}
              onChange={handleChange}
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <Label htmlFor="firstName" value="First Name" />
              <TextInput
                id="firstName"
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label htmlFor="lastName" value="Last Name" />
              <TextInput
                id="lastName"
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div>
            <Label htmlFor="email" value="Email" />
            <TextInput
              id="email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <Label htmlFor="phone" value="Phone" />
            <TextInput
              id="phone"
              name="phone"
              value={form.phone}
              onChange={handleChange}
            />
          </div>

          <div>
            <Label htmlFor="dealership" value="Dealership Name" />
            <TextInput
              id="companyName"
              name="companyName"
              value={form.companyName}
              onChange={handleChange}
            />
          </div>

          <div>
            <Label htmlFor="message" value="Message" />
            <Textarea
              id="questionsComments"
              name="questionsComments"
              rows={4}
              value={form.questionsComments}
              onChange={handleChange}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSubmit}
          isProcessing={loading}
          className="buttonMain "
        >
          Submit
        </Button>
        <Button color="gray" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RequestDemoModal;
